import { useState } from "react";

const STORIES = [
  {
    name: "Lin Xiaoyue",
    from: "Singapore · Member 3 yrs",
    quote:
      "I started out of curiosity, joined with a friend. In three years, I've attended two farm visit days and met the cow I 'adopted.' She's living a more carefree life than I am, honestly (laughs).",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20young%20east%20asian%20woman%20smiling%20softly%20wearing%20a%20cream%20linen%20shirt%2C%20soft%20natural%20window%20light%2C%20warm%20amber%20background%2C%20editorial%20photography%2C%20cream%20tones%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-01&orientation=squarish",
  },
  {
    name: "David Chen",
    from: "Canada · Member 2 yrs",
    quote:
      "I've tried a lot of small-scale investments, and CCF gives me the most peace of mind — I can see the farm's actual data every month. The returns aren't the most exciting, but they're the most stable and the most real.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20middle%20aged%20asian%20canadian%20man%20smiling%20wearing%20a%20soft%20green%20sweater%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-02&orientation=squarish",
  },
  {
    name: "Anna Petersen",
    from: "Germany · Member 4 yrs",
    quote:
      "I treat CCF as an extension of slow living. It keeps me connected to something real — a dairy cow, a pasture. The dividends are just a bonus.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20young%20blonde%20european%20woman%20smiling%20wearing%20a%20cream%20wool%20cardigan%2C%20soft%20natural%20window%20light%2C%20warm%20amber%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-03&orientation=squarish",
  },
  {
    name: "Penny Connor",
    from: "Indonesia · Member 5 yrs",
    quote:
      "I put in my first share five years ago, and now the monthly dividends cover my kid's formula milk. It's not a windfall, but every time the deposit notification comes in, I feel grounded — like an old friend is looking after things from far away.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20chinese%20man%20in%20his%20late%20thirties%20with%20a%20gentle%20smile%20wearing%20a%20navy%20blue%20casual%20blazer%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-04&orientation=squarish",
  },
  {
    name: "Sophie Laurent",
    from: "France · Member 1 yr",
    quote:
      "C'est magnifique. Ever since I moved from Paris to New Zealand, I've been looking for ways to connect with nature. CCF lets me participate in real agriculture without leaving the city — it feels quite magical.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20young%20french%20woman%20with%20curly%20brown%20hair%20smiling%20warmly%20wearing%20a%20soft%20beige%20blouse%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-05&orientation=squarish",
  },
  {
    name: "Marcus Williams",
    from: "Australia · Member 3 yrs",
    quote:
      "I used to be a stock trader, then realized staring at screens all day was draining. CCF's investment rhythm slowed me down — I check reports once a quarter, and spend the rest of my time with family.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20an%20australian%20man%20in%20his%20forties%20with%20a%20kind%20smile%20and%20short%20gray%20hair%20wearing%20a%20soft%20olive%20green%20shirt%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-06&orientation=squarish",
  },
  {
    name: "Swilde Lvy",
    from: "Taiwan · Member 2 yrs",
    quote:
      "I work in auditing, so numbers matter to me. I read every farm report thoroughly — beef yield rates, feed costs, all laid out line by line. This is exactly the kind of transparency I've been looking for in an investment.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20young%20taiwanese%20woman%20with%20a%20calm%20professional%20expression%20wearing%20a%20soft%20dusty%20pink%20blouse%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-07&orientation=squarish",
  },
  {
    name: "James O'Brien",
    from: "Ireland · Member 3 yrs",
    quote:
      "Three generations of my family have raised cattle. After I retired, I put part of my pension into CCF — not because I don't trust my own kin, but because I wanted to carry on the family tradition in a new way. Turns out, it beats the bank by a long shot.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20an%20older%20irish%20man%20with%20a%20warm%20weathered%20smile%20wearing%20a%20soft%20cream%20cable%20knit%20sweater%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-08&orientation=squarish",
  },
  {
    name: "Kim Minseo",
    from: "South Korea · Member 2 yrs",
    quote:
      "Seoul's housing prices made owning even a small patch of land feel like an impossible dream. CCF may not let me live on a farm, but at least it makes me feel a real connection to the land.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20young%20korean%20woman%20with%20a%20gentle%20smile%20wearing%20a%20soft%20oatmeal%20colored%20cardigan%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-09&orientation=squarish",
  },
  {
    name: "Ravi Patel",
    from: "UK · Member 4 yrs",
    quote:
      "I'm a vegetarian. My friends laughed at first — you don't eat beef, so why invest in a cattle farm? I told them: it's precisely because I care about animal welfare that I want to support truly sustainable grazing and pasture-raised farming.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20british%20indian%20man%20in%20his%20early%20thirties%20with%20a%20thoughtful%20smile%20wearing%20a%20soft%20charcoal%20grey%20henley%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-10&orientation=squarish",
  },
  {
    name: "Zhang Meihua",
    from: "Malaysia · Member 5 yrs",
    quote:
      "My son studies in New Zealand, and after I invested through CCF, I started visiting twice a year — to see him and to check on my 'herd.' The farm staff all know me now, and they always brew me the best South Island black tea.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20middle%20aged%20malaysian%20chinese%20woman%20with%20a%20warm%20inviting%20smile%20wearing%20a%20soft%20mint%20green%20blouse%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-11&orientation=squarish",
  },
  {
    name: "Luca Romano",
    from: "Italy · Member 1 yr",
    quote:
      "I do design work in Milan — most of my day is abstract concepts. CCF gives me a sense of groundedness. You can point to exactly which pasture and which farming method you're supporting. It's a great counterbalance for creative work.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20young%20italian%20man%20with%20stylish%20dark%20hair%20and%20a%20creative%20vibe%20smiling%20wearing%20a%20soft%20terracotta%20sweater%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-12&orientation=squarish",
  },
  {
    name: "Hannah Becker",
    from: "Switzerland · Member 3 yrs",
    quote:
      "I use CCF as financial literacy education for my daughter. Every birthday, she gets a personalized annual farm report with a photo of her 'adopted' cow. She's ten now and already discusses feed prices and exchange rates with me.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20swiss%20woman%20in%20her%20mid%20thirties%20with%20a%20confident%20warm%20smile%20wearing%20a%20soft%20cream%20silk%20blouse%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-13&orientation=squarish",
  },
  {
    name: "Skyblue",
    from: "USA · Member 4 yrs",
    quote:
      "Four years ago I was a fresh graduate, putting my very first paycheck into CCF. Now I have my own startup, but every quarter when the dividend comes in, I still remember that simple, brave decision I made back then.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20chinese%20man%20in%20his%20early%20thirties%20with%20a%20confident%20gentle%20smile%20wearing%20a%20soft%20camel%20brown%20cashmere%20sweater%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-14&orientation=squarish",
  },
  {
    name: "Maria Gonzalez",
    from: "Spain · Member 4 yrs",
    quote:
      "I'm from the suburbs of Barcelona, and my grandparents were farmers. After moving to the city, I always felt something was missing. CCF helped me reconnect with that relationship to the land — even if only as an investor. Every weekend when I cook, I feel closer to where my ingredients come from.",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20studio%20portrait%20of%20a%20spanish%20woman%20in%20her%20late%20thirties%20with%20a%20passionate%20warm%20smile%20and%20dark%20wavy%20hair%20wearing%20a%20soft%20rust%20colored%20blouse%2C%20soft%20natural%20window%20light%2C%20warm%20cream%20background%2C%20editorial%20photography%2C%20highly%20detailed%20realistic%20face&width=400&height=400&seq=vef-avatar-15&orientation=squarish",
  },
];

const INITIAL_VISIBLE = 3;

export default function Stories() {
  const [showAll, setShowAll] = useState(false);
  const visibleStories = showAll ? STORIES : STORIES.slice(0, INITIAL_VISIBLE);

  return (
    <section id="stories" className="w-full bg-background-100/60">
      <div className="w-full px-6 md:px-10 lg:px-14 py-24 md:py-32">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold tracking-wide">
              <i className="ri-chat-heart-line"></i>
              Member Stories
            </div>
            <h2
              className="mt-5 text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-tight"
              style={{ fontFamily: "Fraunces, serif" }}
            >
              50,000+ Members'<br className="hidden md:block" />
              <span className="text-primary-600">Real Life Snapshots</span>
            </h2>
          </div>
          <div className="flex items-center gap-6">
            <div className="text-center">
              <div
                className="text-3xl md:text-4xl font-heading font-semibold text-primary-700"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                4.92
              </div>
              <div className="mt-1 flex items-center justify-center gap-0.5 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <div className="mt-1 text-xs text-foreground-600">From 3,200+ Community Reviews</div>
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {visibleStories.map((s) => (
            <div
              key={s.name}
              className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200 flex flex-col"
            >
              <div className="flex items-center gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>

              <p
                className="mt-6 text-base md:text-lg text-foreground-800 leading-relaxed font-heading"
                style={{ fontFamily: "Fraunces, serif" }}
              >
                &ldquo;{s.quote}&rdquo;
              </p>

              <div className="mt-8 pt-6 border-t border-background-200 flex items-center gap-3">
                <img
                  src={s.avatar}
                  alt={s.name}
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{s.name}</div>
                  <div className="text-xs text-foreground-600">{s.from}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {STORIES.length > INITIAL_VISIBLE && (
          <div className="mt-10 flex justify-center">
            <button
              onClick={() => setShowAll(!showAll)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-300 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {showAll ? (
                <>
                  Show Less
                  <i className="ri-arrow-up-s-line"></i>
                </>
              ) : (
                <>
                  Show More
                  <span className="text-xs text-foreground-500 ml-1">
                    ({STORIES.length - INITIAL_VISIBLE} more stories)
                  </span>
                  <i className="ri-arrow-down-s-line"></i>
                </>
              )}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}